<template lang="pug">
	div
		#sfc-main-container.sfc-container-redesign-v1
			sfc-sentry
			sfc-hello-bar-v3
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-login
			sfc-forgot-password
			sfc-enroll-now-urgency-widget(:inPage="false")
			sfc-menu
			sfc-menu-mobile
			sfc-onboarding-modal-v2
			sfc-header(v-if="!isFinancialAidCalculatorForPortals()")
			#sfc-main-content
				b-container.padding-only-desktop
					b-row(no-gutters)
						b-col.col-desktop-padding(cols="12" lg="8")
							nuxt
						b-col.d-md-none.d-lg-block.d-sm-none.d-none.side(lg="4")
							.side-cont
								sfc-sidebar
				no-ssr(v-if="!userSubscribed() && !isFinancialAidCalculatorForPortals()")
					b-row#bottom-ad
						.col-md-12.col-sm-12.col-xs-12.ad-align-center
							.bottom-banner(style="")
								sfc-dfp-ad(ad-unit="savingforcollege_other_bottom_leaderboard" sizes="[[600,230], [728,90]]")
			sfc-footer
			no-ssr
				sfc-gdpr-banner
		no-ssr
			sfc-college-savings-questions-modal
</template>

<style lang="stylus">
	// @import '~assets/css/redesign-v1/common.styl'
</style>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	.container-fluid
		padding: 0
		> .row
			margin: 0
			> .col
				padding: 0
	.padding-only-desktop
		padding: 0 !important
		.col-desktop-padding
			@media (min-width: 768px)
				padding: 0 15px !important
	.side
		border-left 1px solid sfc-pale-gray
		overflow: hidden

>>> #sfc-main-content
	.sidebar-container
		padding-left: 15px
		padding-right: 15px
		h3
			font-size: body-font-size-lg
		a
			text-decoration: none !important
		p
			font-size: body-font-size-sm
		.more-articles
			color: sfc-blue-hover
			text-decoration: underline
		.main-table-container
			.tabs
				a
					&.tab
						color: body-font-color !important
			table
				&.table
					tr:nth-child(2n)
						background: transparent !important
			p
				font-size: body-font-size
			a
				color: body-font-color
				&:hover
					color: sfc-blue-hover
			.view-full-list
				text-decoration: underline !important
				color: body-font-color
				margin-top: 20px
				margin-bottom: 60px
</style>



<script>
import SfcHeader from '@/layouts/common/sfc-header-slim'
import SfcSidebar from '@/common/components/sfc-sidebar'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcHelloBarV3 from '@/common/components/hello-bar/sfc-hello-bar-v3'
import SfcEnrollNowUrgencyWidget from '@/common/components/redesign-v1/sfc-enroll-now-urgency-widget'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'

export default {
	components: {
		SfcHeader,
		SfcFooter,
		sfcCollegeSavingsQuestionsModal,
		SfcHelloBarV3,
		SfcEnrollNowUrgencyWidget,
		SfcSidebar,
		SfcMenu,
		SfcMenuMobile,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2
	},
	computed: {
		containerClass: function (){
			let isSfcFinancialAidCalculator = this.$route.path.indexOf('/financial-aid-calculator') >= 0 && this.$route.path.indexOf('/financial-aid-calculator-portals') < 0
			return isSfcFinancialAidCalculator ? 'container' : 'container-fluid'
		}
	},

	methods: {
		isFinancialAidCalculatorForPortals(){
			return this.$route.path.indexOf('/financial-aid-calculator-portals') >= 0
		},
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		}
	}
}
</script>
